import {jwtDecode} from 'jwt-decode'

export function hasPasswordResetTokenInUrl(): boolean {
  if (typeof window === 'undefined') return false

  const decoded = decodeURIComponent(window.location.href)
  const queryString = decoded.split('?')[1]
  if (!queryString) return false

  const token = new URLSearchParams(queryString).get('token')
  if (!token) return false

  try {
    const otp = jwtDecode(token) as {operation?: string}
    return otp.operation === 'define-password'
  } catch {
    return false
  }
}
